import { useSearchParams } from "utils/customHooks"

export const FROM_LINK = "from_link"

export function useFromLink() {
    const searchParams = useSearchParams()
    return searchParams.get(FROM_LINK) ?? undefined
}
